export const ENGLISH = 'EN';
export const ARABIC = 'AR';
export const BOT_RESERVED_WORDS = ['quit', 'askProfile.convo.say.1', 'typing', 'endConversation']; // these array represent the bot response that won't be displayed.
export const CUSTOMER_RESERVED_WORDS = ['hello', 'restart']; // similarly to the bot_reserved_words but for cutomer
// export const THREAD_RESERVED_WORDS = ['target_amount_validate_thread'];

export const WEBSOCKET_STATUS_NOT_CONNECTED = 0;
export const WEBSOCKET_STATUS_CONNECTING = 1;
export const WEBSOCKET_STATUS_CONNECTED = 2;
export const WEBSOCKET_STATUS_CLOSED = 3;
export const WEBSOCKET_TIMEOUT_SECONDS = 5;
export const WEBSOCKET_PREFIX = 'REDUX_WEBSOCKET';

export const END_CONVERSATION_START_AGAIN = 'endConversationStartAgain';
export const END_DIALOG = 'endConversation';
export const END_CONVERSATION_THREAD = 'end_conversation_thread';

export const delayTime = 500;
export const expirationTime = 900000;
export const inactiveTime = 50000;

export const COMPONENT_TYPE = {
  NAME_INPUT: 'nameInput',
  AGE_PICKER: 'agePicker',
  ESTIMATE_WEALTH: 'estimateWealth',
  FINANCIAL_GOAL: 'financialGoal',
  TARGET_AMOUNT: 'targetAmount',
  YEAR_ACHIEVE: 'yearAchieve',
  RISK_ASSESSMENT: 'riskAssessment',
  RISK_QUESTION: 'riskQuestion',
  RISK_QUESTION_GAIN_LOSS: 'riskQuestionGainLoss',
  RISK_QUESTION_INVESTMENT_PORTFOLIO: 'riskQuestionInvestmentPortfolio',
  PLAN_WITHDRAW: 'planWithdraw',
  GEOGRAPHICALLY: 'geographically',
  ISLAMIC_INVESTMENT: 'islamicInvestment',
  QUALIFIED_INVESTOR: 'qualifiedInvestor',
  INITIAL_CAPITAL: 'initialCapital',
  ANNUAL_CONTRIBUTION: 'annualContribution',
  KEY_FACTS: 'keyFacts',
  ITEM_LIST: 'itemList',
  PIE_CHART: 'pieChart',
  PAST_PERFORMANCE: 'pastPerformance',
  LINE_CHART: 'lineChart',
  GOAL: 'goal',
  GOAL_ALT: 'goalAlt',
  PORTFOLIO_STAT: 'portfolioStats',
  HORIZONAL_BAR_CHART: 'horizontalBarChart',
  BAR_CHART: 'barChart',
  OPTION_WITH_ICON: 'optionWithIcon',
  ADVISOR_PICKER: 'advisorPicker',
  DATE_PICKER: 'datePicker',
  TIME_PICKER: 'timePicker',
  OPTION_BUTTON: 'optionButton',
  LOCATION_INPUT: 'locationInput',
  TEXT_INPUT: 'textInput',
  RISK_POPUP: 'riskPopup',
  PICK_LOCATION: 'pickLocation',
  EMAIL: 'email',
  PHONE_NUMBER: 'phone_number',
  APPLICATION_OPTIONS: 'applicationOptions',
  INVEST_IN_GOLD: 'investInGold',
  OPTIONAL_EMAIL: 'optionalEmail',
  INVESTMENT_SUMMARY: 'investmentSummary',
  ASSETS_ALLOCATION: 'assetAllocation',
  PRODUCT_OVERVIEW: 'productOverview',
  GOAL_SUMMARY: 'goalSummary',
};

export const PATH = {
  CHAT: '/chat',
  INVESTOR_PROFILE: '/investor-profile',
  JOURNEY_OVERVIEW: '/journey-overview',
  RISK_ASSESSMENT: '/risk-assessment',
  INVESTMENT_PREFERENCE: '/investment-preference',
  INVESTMENT_SUMMARY: '/investment-summary',
  PRODUCT_RECOMMENDATION: '/product-recommendation',
  FUND_FACTSHEET: '/fund-factsheet/:id',
  ASSETS_ALLOCATION: '/assets-allocation',
  CALL_TO_ACTION: '/call-to-action',
  THANK_YOU: '/thank-you',
  HOME: '/', // previoiusly /home
  GOAL_SUMMARY: '/goal-summary',
  ABOUT_INVESTMENT_ADVICE: '/about-investment-advice',
  LANGUAGE: '/language', // previoiusly '/'
  WELCOME: '/welcome',
};

export const DIALOG = {
  INVESTOR_PROFILE: 'investor-profile',
  RISK_ASSESSMENT: 'risk-assessment',
  INVESTMENT_PREFERENCE: 'investment-preference',
  CALL_TO_ACTION: 'call-to-action',
};

export const FUND_TYPES = {
  MUMTAZ: 'mumtaz',
  MARKAZ: 'markaz',
  ISLAMIC: 'islamic',
  ISHARES: 'ishares',
  DESCRETIONARY: 'descretionary',
  MFIF: 'mfif',
};

export const COLORS = ['#87C474', '#68CBC2', '#E6983A', '#FDCD5A', '#FC9791'];

export const ENDPOINTS = {
  ASSETS_ALLOCATION: '/asset-allocation',
  FUND_FACTSHEET_DETAIL: '/funds/details',
  FINANCIAL_GOAL: '/financial-services/investment-goal',
  USER: '/user',
  CONVERSATION: '/conversation',
  VARS: '/conversation/vars',
  STEP: '/step',
  MAKE_APPOINTMENT: '/appointment',
  EMAIL: '/email',
};

export const STATUS = {
  COMPLETED: 'completed',
  INCOMPLETE: 'incompleted',
  DEFAULT: 'default',
};

export const STORAGE_KEY = {
  FIRST_TIME_VISIT: 'FIRST_TIME_VISIT',
  EXPIRATION_DATE: 'EXPIRATION_DATE',
  CURRENT_PRODUCT_SLIDE: 'CURRENT_PRODUCT_SLIDE',
};

export const TRACKING_EVENT = {
  SELECT: 'select',
  ACCESS_PAGE: 'access_page',
  PAYLOAD: 'payload',
};

export const TRACKING_KEY = {
  AGE: 'age',
  NAME: 'name',
  FINANCIAL_GOAL: 'financial_goal',
  ESTIMATE_WEALTH: 'estimate_wealth',
  GEOGRAPHICAL_INVESTMENT: 'geographical_investment',
  ISLAMIC_INVESTOR: 'islamic_investor',
  REGULATORY_INVESTOR: 'regulatory_investor',
  RISK_PROFILE_OPTION: 'risk_profile_option',
  RISK_PROFILE: 'risk_profile',
  CTA: 'cta',
  EMAIL: 'email',
  PHONE: 'phone',
  DATE_APPOINTMENT: 'date_appointment',
  TIME_APPOINTMENT: 'time_appointment',
  LOCATION_APPOINT: 'location_appointment',
  RELATIONSHIP_MANAGER: 'relationship_manager',
  PORTFOLIO: 'portfolio',
  COMPLETE_FLOW: 'complete_flow',
  UNIQUE_USER: 'unique_user',
  RETURN_VISITOR: 'return_visitor',
  USER_EXPERIENCE: 'user_experience',
  TIME_SPENT: 'time_spent',
  DEVICE: 'device',
  BROWSER: 'browser',
  ADVISOR_APPOINTMENT: 'advisor_appointment',
  COMPLETE_PROSPECT: 'complete_prospect',
  COMPLETE_RATING: 'complete_rating',
  COUNTRY: 'country',
  DROP_OFF: 'drop_off',
  PWA_INSTALLED: 'pwa_installed',
  COB_LINK_CLICKED: 'cob_link_clicked',

};

export const TRACKING_VALUE = {
  SIXTEEN_AND_ABOVE: '60_and_above',
  FIFTY_TO_FIFTYNINE: '50_59_yrs_old',
  FOURTY_TO_FOURTYNINE: '40_49_yrs_old',
  THIRTY_TO_THIRTYNINE: '30_39_yrs_old',
  FIFTEEN_TO_TWENTYNINE: '15_29_yrs_old',

  EMERGING_MARKET: 'emerging_market',
  KUWAIT_GCC: 'kuwait_gcc',
  DEVELOPED_MARKET: 'developed_market',
  GLOBAL: 'global',
  GOLD: 'gold',

  PRE_RISK_PROFILE: 'pre_risk_profile',
  FORMAL_RISK_PROFILE: 'formal_risk_profile',
  OFFICE_LOCATION: 'Markaz Office',
};


export const PRODUCT_TYPE = {
  ETF: 'etf',
  MUTUAL_FUND: 'mutual_fund',
  MARKAZ_REAL_ESTATE: 'markaz_real_estate',
};

export const PRODUCT_COMPONENT = {
  KEY_FACTS: 'keyFacts',
  HORIZONTAL_BAR_CHART: 'horizontalBarChart',
  PIE_CHART: 'pieChart',
  LINE_CHART: 'lineChart',
  ITEM_LIST: 'itemList',
  PORTFOLIO_STATS: 'portfolioStats',
  PAST_PERFORMANCES: 'pastPerformance',
};


export const EMAIL_THREAD = {
  PROCEED_ACTION: 'proceed_action',
  SELECT_APPLICATION: 'select_application',
  SELECT_TIME: 'select_time',
  EMAIL_THREAD: 'email_thread',
};

export const CUSTOME_STOP_STEP = {
  SIMULATION_ONLY: 'simulation_only',
  OPEN_ACCOUNT_LATER: 'open_account_later',
  APPOINTMENT_EMAIL: 'appointment_email',
  OPEN_ACCOUNT_NOW: 'open_account_now',
  APPOINTMENT_DATEPICKER: 'appointment_datePicker',

  APPOINTMENT_TIMEPICKER: 'appointment_timePicker',

  APPOINTMENT_PHONE: 'appointment_phone',
};
